import { defineStore } from 'pinia'
import { ServoConfig, WsServo } from '@/api/servo/types'
import { Categorys, Homelist } from '@/api/home/type'
import { VideoDetail } from '@/api/video/types'
import { LoginUser } from '@/api/types'
import { GLOBAL_URL, ERROR_CODES, BLACK_LIST, CURRENCY_LIST, LANGUAGE_LIST, WS_SERVER } from '@/enums'
import * as type from './types'
import { getErrorMsg, getWsHeader, getChannel, getDeviceInfo, sort } from '@/utils'
import { showToast } from 'vant'
import { changeUserInfo } from '@/api'
import { Wallet } from '@/api/home/type'
import { Chat, HeaderMsg, SignParam, SignRes, Receive, Lamp, VipInfo, VipConfig, ChatTransferParam, VipItems, VipRules, Acticity } from './types'
import router from '@/router'
import { showNotify } from 'vant'
import i18n from '@/language'
import { useSubscript } from '@/components/notice/hook/useSubscribe'
import { Channel } from '@/api/wallet/type'
import bus, { EVENT_KEY } from '@/utils/bus'
import { Log } from '@/api/log'
import dayjs from 'dayjs'
import { Partner } from '@/api/partner/types'
import { getPartnerInfo } from '@/api/partner/index'
import popupManager from '@/utils/PopupManager'

/**
 * 用户信息
 * @methods setUserInfos 设置用户信息
 */
export const useBaseStore = defineStore('playTok_base', {
    state: (): Partial<{
        bodyHeight: number
        bodyWidth: number
        userInfo: Partial<LoginUser>
        wallet: Partial<Wallet>
        maskDialog: boolean
        maskDialogMode: string
        excludeNames: string[]
        showLogin: boolean
        token: string
        loading: boolean
        judgeValue: number
        homeRefresh: number
        servoConfig: Partial<ServoConfig>
        gameConfig: Partial<WsServo>
        gameserver: any
        isMuted: boolean
        lang: string
        systemNum: number
        transactionNum: number
        activeNum: number
        gameLogined: boolean
        loginCb: any[]
        SYSTEMList: Chat[]
        TRANSACTIONList: Chat[]
        chatList: {
            [key: string]: Chat[]
        }
        unReadCount: {
            [key: string]: number
        }
        shareId: number
        curSymbol: {
            [key: string]: string
        }
        signId: string
        videoCach: Map<string, string>
        newUser: boolean
        loginTime: number
        showVideoDrive: boolean
        showDownload: boolean
        tgInitData: { [key: string]: any }
        showMenu: boolean
        conneting: boolean
        wsList: string[]
        wsIdx: number
        tabData: Categorys[]
        gameList: Homelist
        homeShow: boolean
        showBuoy: boolean
        lampList: Lamp[]
        vipInfo: VipInfo
        vipConfig: VipConfig[]
        chargeDate: {
            [key: string]: string[]
        }
        signDate: {
            [key: string]: string[]
        }
        partnerDate: {
            [key: string]: {
                date: string[]
                time: number
            }
        }
        reelsConfig: VideoDetail
        sex: boolean

        dramaStatus: {
            [key: string]: {
                like: number
                retweet: number
                favorite: number
            }
        }
        buyVideoParam: null | {
            [key: string]: any
        }
        partnerInfo: Partner.Info
        videoPlayed: boolean
        depositOrder: string
        bonus: number
        prevGameTag: string
        depositeChannel: Channel[]
        vipItems: VipItems
        VipRules: VipRules
        pointAnimate: boolean
        // [key: string]: any
        entryList: {
            [key: string]: {
                title: string
                data: {
                    code?: number
                    acticity?: Acticity
                }
                icon: string
                type: string
                jumpType?: string
                jump?: string
            }
        }
        entryVisible: boolean
        closeBind: boolean
        toastConfig: {
            [key: string]: any
        }
        parrnerRelationDate: string
    }> => {
        return {
            bodyHeight: document.body.clientHeight as number,
            bodyWidth: document.body.clientWidth as number,
            userInfo: {},
            wallet: {
                currency: 'PHP',
            },
            maskDialog: false,
            maskDialogMode: 'dark',
            excludeNames: ['notice'],
            showLogin: false,
            token: '', // 用户token
            loading: false,
            judgeValue: 20,
            homeRefresh: 60,
            servoConfig: {},
            gameConfig: {},
            gameserver: null,
            isMuted: true, // 视频静音
            lang: '',
            systemNum: 0, // 系统消息数量
            transactionNum: 0, // 交易消息数量
            activeNum: 0, // 活动消息数量
            gameLogined: false, // 是否登录到游戏服务器
            loginCb: [], // 未登录游戏服务时发出的请求
            SYSTEMList: [], // 系统消息列表
            TRANSACTIONList: [], // 交易消息列表
            chatList: {}, // 聊天信息
            unReadCount: {}, // 未读消息数量
            shareId: 0,
            curSymbol: {
                PHP: '₱',
            }, // 货币符号配置
            signId: '',
            videoCach: new Map(),
            newUser: false,
            loginTime: 0, // 上次登录时间
            showVideoDrive: false,
            showDownload: true,
            tgInitData: {},
            showMenu: false,
            conneting: false,
            wsList: WS_SERVER,
            wsIdx: 0,
            tabData: [],
            gameList: {},
            homeShow: true,
            showBuoy: true,
            lampList: [],
            vipInfo: {},
            vipConfig: [],
            reelsConfig: {},
            chargeDate: {},
            signDate: {},
            sex: false,
            dramaStatus: {},
            buyVideoParam: null,
            partnerInfo: {},
            videoPlayed: false,
            partnerDate: {},
            depositOrder: '',
            bonus: 0,
            prevGameTag: '',
            depositeChannel: [],
            vipItems: {},
            vipRules: {},
            pointAnimate: false,
            entryList: {
                firstpayment: {
                    title: 'Fisrt_deposit_1',
                    data: {},
                    icon: '1stPay',
                    type: 'activity',
                },
                // adduppayment: {
                //     title: 'Lucky_icon',
                //     data: {},
                //     icon: 'Lucky',
                //     type: 'activity',
                // },
                // vippayment: {
                //     title: 'wed_wallet_viponly',
                //     data: {},
                //     icon: 'VIPOnly',
                //     type: 'activity',
                // },
                onlinesign: {
                    title: 'seven_day_icon',
                    data: {},
                    icon: '7day',
                    type: 'activity',
                },
                // welfare: {
                //     title: 'wed_gift',
                //     data: {},
                //     icon: 'WedGift',
                //     type: 'activity',
                //     jumpType: 'page',
                //     jump: '/welfare',
                // },
                reliefaward: {
                    title: 'relief_fund_icon',
                    data: {},
                    icon: 'Relief',
                    type: 'activity',
                },
                // triggerpayout: {
                //     title: 'spin_button',
                //     data: {},
                //     icon: 'Spin',
                //     type: 'activity',
                // },
                // tasks: {
                //     title: 'quest_hub',
                //     data: {},
                //     icon: 'Quest',
                //     type: 'activity',
                //     jumpType: 'menuSet',
                //     jump: 'quest',
                // },
                vip: {
                    title: 'VIP',
                    data: {},
                    icon: 'VIP',
                    type: 'page',
                    jumpType: 'page',
                    jump: '/vip',
                },
                msg: {
                    title: 'Chat_interface_title',
                    data: {},
                    icon: 'message',
                    type: 'page',
                    jumpType: 'page',
                    jump: '/message',
                },
                Bonusshop: {
                    title: 'menu_bonus_shop',
                    data: {},
                    icon: 'Bonusshop',
                    type: 'page',
                    jumpType: 'page',
                    jump: '/bonus-shop',
                },
            },
            entryVisible: true,
            closeBind: false,
            toastConfig: {
                show: false,
                type: '',
                tip: '',
            },
            parrnerRelationDate: '',
        }
    },
    getters: {
        // 未读消息数量
        noticeNum(state) {
            console.log((state.unReadCount, '(state.unReadCount'))
            return Object.keys(state.unReadCount).reduce((prev, key) => {
                return prev + (state.unReadCount[key] || 0)
            }, 0)
        },
        tabMenu(state) {
            // @ts-ignore
            const history = state.gameList?.history
            if (history?.length && history?.length > 5) {
                const tabData = [...state.tabData]
                // @ts-ignore
                tabData.splice(1, 0, {
                    name: 'Game_type_history',
                    picture: '',
                    type: 'history',
                })
                return tabData
            }
            return state.tabData
        },
        menuData(state) {
            return state.tabData.filter((item) => !['HOT', 'NEW'].includes(item.type.toUpperCase()))
        },
        getVideoCache(state) {
            return (key) => state.videoCach.get(key)
        },
        // 货币符号
        cureencySymbol() {
            return () => {
                return '₱'
            }
        },
        currencyList() {
            return CURRENCY_LIST
        },
        languageList() {
            return LANGUAGE_LIST.map((item) => {
                return {
                    ...item,
                    value: item.language.replace(/_([a-zA-Z])/g, (match, letter) => '-' + letter.toUpperCase()),
                }
            })
        },
        defaultCurrency() {
            return 'PHP'
        },
        defaultLangguage() {
            return 'tl-PH'
        },
        showDown(state) {
            return (
                location.host !== 'www.playtok999.com' &&
                !localStorage.getItem('__rb_6764554973_data') &&
                state.showDownload &&
                !window.matchMedia('(display-mode: standalone)').matches &&
                !(getDeviceInfo().os === 'iOS' && window.navigator.standalone)
            )
        },
        // 是否是大区代理
        isAgent(state) {
            return state.token && state.userInfo?.agentid === state.userInfo?.uid
        },
        getWsServer() {
            return this.wsList[this.wsIdx++]
        },
        getBanner() {
            return this.gameList.banner
        },
        curVipConfig() {
            return this.vipConfig.find((item) => item.level === this.vipInfo.curLevel)
        },
        getApp() {
            if (
                window.matchMedia('(display-mode: standalone)').matches ||
                (getDeviceInfo().os === 'iOS' && window.navigator.standalone) ||
                localStorage.getItem('__rb_6764554973_data') ||
                localStorage.getItem('pwa-link-id')
            ) {
                return 'pwa'
            }
            return 'h5'
        },
        getVip() {
            const { exp, max, curLevel } = this.vipInfo
            const isMax = curLevel === 12
            return {
                isMax,
                leftExp: isMax ? 0 : Number((max - exp).toFixed(2)),
                level: curLevel,
                nextLevel: isMax ? curLevel : curLevel + 1,
                exp,
                max,
            }
        },
        isVip1OrNeedrecharge() {
            const { exp, max, rechargeMax, recharge, curLevel } = this.vipInfo || {}
            return rechargeMax ? rechargeMax - recharge > 0 : curLevel === 0 && max - exp > 0
        },
    },
    actions: {
        showFailToast(tip) {
            this.toastConfig = {
                show: true,
                tip,
                type: 'error',
            }
        },
        showSuccessToast(tip) {
            this.toastConfig = {
                show: true,
                tip,
                type: 'succes',
            }
        },
        setEntryIconData(key, data) {
            if (key in this.entryList) {
                this.entryList[key].data = data
            }
        },
        setMenu(data) {
            this.showMenu = data
        },
        setvipInfo(data) {
            this.vipInfo = data.info
            this.vipConfig = data.config
            this.vipRules = data.rules
            this.vipItems = data.items
        },
        setHomeData(data) {
            this.tabData = data.categorys
            this.gameList = data
            this.bonusStoreEnabled = data.bonusStoreEnabled || false
        },
        getGameName(gamefirm) {
            return this.gameList.gamefirms[gamefirm].tag
        },
        getGameList(type) {
            const { gameconfigs, gamepages, gameStat, history } = this.gameList
            if (type === 'history') {
                return history
                    ?.sort((a, b) => b.time - a.time)
                    .map((game) => {
                        return { ...game, ...gameconfigs[game.gametag], ...gameStat[game.gametag] }
                    })
            }

            const game = sort(gamepages[type])?.map((game) => {
                return { ...game, ...gameconfigs[game.gametag], ...gameStat[game.gametag] }
            })
            return [...game]
        },
        updatLamp(lamp) {
            if (lamp.title === 'SystemMaintain' || this.wallet.currency === lamp.cron) {
                this.lampList = [...this.lampList, lamp]
            }
        },
        clearLamp() {
            this.lampList = []
        },
        setTgData(data) {
            this.tgInitData = data
        },
        setVideoCache(key, val) {
            this.videoCach.set(key, val)
        },
        setInit(data) {
            const { currency, language } = data
            this.setWallet(currency)
            this.lang = language
            this.userInfo = { ...this.userInfo, curcurrency: currency.currency, curlanguage: language, guideCurrency: true, guideLanguage: true }
        },
        setMaskDialog(val) {
            this.maskDialog = val.state
            if (val.mode) {
                this.maskDialogMode = val.mode
            }
        },
        updateExcludeNames(val) {
            if (val.type === 'add') {
                if (!this.excludeNames.find((v) => v === val.value)) {
                    this.excludeNames.push(val.value)
                }
            } else {
                const resIndex = this.excludeNames.findIndex((v) => v === val.value)
                if (resIndex !== -1) {
                    this.excludeNames.splice(resIndex, 1)
                }
            }
        },
        // 设置服务器配置
        setServoConfig(val) {
            this.servoConfig = val
        },
        setToken(token) {
            this.token = token
        },
        setNewUser(isNew) {
            this.showVideoDrive = this.newUser = isNew || false
        },
        setUserInfo(val) {
            this.userInfo = val
        },
        setWallet(val) {
            this.wallet = { ...this.wallet, ...val }
        },
        updateUserInfo(val) {
            this.userInfo = { ...this.userInfo, avatar: val }
        },
        logOut() {
            this.token = ''
            this.userInfo = {}
            this.unReadCount = {}
            this.chatList = {}
            this.SYSTEMList = []
            this.TRANSACTIONList = []
            this.diconnect()
            this.vipInfo = {}
            this.VipConfig = []
            Object.keys(this.entryList).forEach((key) => {
                this.setEntryIconData(key, {})
            })
            this.gameLogined = false
            bus.emit(EVENT_KEY.LOGOUT)
            popupManager.restStatus()
        },
        // 手动系统，充值，好友消息分发
        distributeMsg(msg) {
            if (getChannel(10001, this.userInfo.uid) === msg.channel) {
                return
            }
            const channel = msg.channel
            const isExit = this.chatList[channel]?.some((item) => item.id === msg.id)
            if (!isExit) {
                this.chatList[channel] = [...(this.chatList[channel] || []), { ...msg }]
            }
            if (msg?.content.sender !== this.userInfo.uid && msg.event !== 'login' && !isExit) {
                this.unReadCount[channel] = (this.unReadCount[channel] || 0) + 1
            }

            bus.emit(EVENT_KEY.MESSAGE_UPDATE, msg)
            const isNotify = msg?.event === 'notify'
            if (channel.includes('20000') || isNotify) {
                const { translateTtoText } = useSubscript('')
                showNotify({
                    className: 'common-notice',
                    duration: 5000,
                    //@ts-ignore
                    message: i18n.global.t(msg.content.text, translateTtoText(msg)),
                    onClick: () => {
                        router.push({
                            path: '/message',
                        })
                    },
                })
            }
        },
        diconnect() {
            this.wsIdx = 0
            if (this.gameserver) {
                this.gameserver.disconnect(-1, 'logout')
                this.gameserver.cleanup()
                localStorage.removeItem('current.session')
                this.gameserver = null
            }
        },
        // 请求封装
        async request<T>(url, params = {}, conf): Promise<T> {
            const config = Object.assign({ loading: true, tip: true }, conf)
            console.log(params, 'params ', url)
            return new Promise((resolve) => {
                // 处理刷新页面时 未登录游戏服务时发送的请求
                if (!this.gameLogined && !BLACK_LIST.includes(url)) {
                    this.loginCb.push(resolve)
                    return
                }
                resolve(0)
            })
                .then(() => {
                    this.gameserver && config.loading && (this.loading = true)
                    return this.gameserver
                        ?.request(url, params)
                        .then((response) => {
                            config.loading && (this.loading = false)
                            console.log(response, 'response ', url, params)
                            if (!response) {
                                this.gameserver.handleClosed()
                                return Promise.reject('soket断连无返回值')
                            }

                            if (response.code && response.code !== ERROR_CODES.OK) {
                                if (config.tip) {
                                    const errorTip = getErrorMsg(url, response.code)
                                    showToast({
                                        message: i18n.global.t(errorTip),
                                        zIndex: 4000,
                                    })
                                }
                            }
                            return response
                        })
                        .catch((e) => {
                            console.log(e)
                            config.loading && (this.loading = true)
                        })
                })
                .catch(() => {
                    config.loading && (this.loading = true)
                })
        },
        async gameInit() {
            this.request(GLOBAL_URL.GameInit, {}, { loading: false, tip: false })
        },
        // 获取个人信息
        async getProfile() {
            const response: any = await this.request(GLOBAL_URL.ProfilesAsync, {})
            this.userInfo = response.metadata
        },
        // 更改个人信息
        async changeUserInfo(pramas: type.ChangeUserInfo) {
            const response: any = await changeUserInfo(pramas)
            if (response.code === ERROR_CODES.OK) {
                this.userInfo = { ...this.userInfo, nickname: response.pro.nickname }
            }
            return response
        },
        // 绑定手机号
        async bindPhone(params: type.BindPhone) {
            const response: any = await this.request(GLOBAL_URL.BindPhone, params)
            if (response.code === ERROR_CODES.OK) {
                this.getProfile()
            }
            return response
        },
        // 绑定邀请人
        async bindInviter(params: type.BindInviter, conf = {}) {
            const response: any = await this.request(GLOBAL_URL.ShareInviteBind, params, conf)
            if (response?.code === 200) {
                this.getProfile()
            }
            return response
        },
        // 游戏订阅
        async gameSubscribe(params: type.GameSubscribe) {
            return this.request(GLOBAL_URL.GameSubscribe, params, { tip: true })
        },
        async gameUnSubscribe() {
            return this.request(GLOBAL_URL.GameUnSubscribe)
        },
        // 获取vip信息
        async getVipInfo(loading = true, tip = true) {
            return this.request(
                GLOBAL_URL.Vip,
                {},
                {
                    tip: false,
                    loading,
                }
            )
        },
        // vip领取
        async pickVipRewards(params = {}) {
            return this.request(GLOBAL_URL.PickRewads, params)
        },

        async triggerVip(params = {}) {
            return this.request(GLOBAL_URL.triggerVip, params)
        },
        async gameLogOut() {
            if (!this.gameserver) {
                return
            }
            this.gameserver.disconnect(-1, 'logout')
            this.gameserver.cleanup()
            localStorage.removeItem('current.session')
            this.gameserver = null
        },

        async SessionLogin() {
            Log({
                event: 'ws_login',
                content: {
                    ctime: dayjs().format('YYYY-MM-DD HH:mm:ss.SSS'),
                    retryCounter: this.gameserver.retryCounter,
                    host: this.gameserver._remote.href,
                },
            })
            const response: any = await this.request(
                GLOBAL_URL.SessionLogin,
                {
                    token: this.token,
                    package: getWsHeader(),
                },
                { tip: false }
            )

            if (response.code === ERROR_CODES.Gone) {
                this.logOut()
                router.push('/login')
                return
            } else if (response.code === 100) {
                // this.gameLogOut()
                // this.gameserver.emit('reconnect')
                this.gameserver.handleClosed()
                return
            }
            this.token = ''
            const { newtoken, metadata, items } = response
            // if (!this.lang && metadata.curlanguage) {
            //     this.lang = metadata.curlanguage
            //     location.reload()
            // }
            // 是tg分享
            if (metadata?.tgShareId) {
                this.bindInviter(
                    {
                        shareid: metadata.tgShareId, // 邀请人id
                        auto: true, //是否自动绑定
                        from: metadata.shareFrom, //渠道来源
                    },
                    { loading: false, tip: false }
                )
            }
            this.userInfo = metadata
            this.token = newtoken
            this.wallet = { ...items, currency: metadata.curcurrency }
            this.gameLogined = true
            if (this.loginCb.length) {
                this.loginCb.forEach((cb) => {
                    cb && cb()
                })
                this.loginCb = []
            }
            Log({
                event: 'ws_logined',
                content: {
                    ctime: dayjs().format('YYYY-MM-DD HH:mm:ss.SSS'),
                    retryCounter: this.gameserver.retryCounter,
                    host: this.gameserver._remote.href,
                },
            })
        },
        // 提现
        async payOut(params: type.PayOut): Promise<type.PayOutRes> {
            return this.request(GLOBAL_URL.PayOut, params)
        },
        // 重新进入游戏
        async Rejoingames() {
            return this.request(GLOBAL_URL.Rejoingames, {})
        },
        // 礼物兑换码
        async exchangeGiftCdk(cdkcode: string) {
            return this.request(GLOBAL_URL.GiftCdk, { cdkcode })
        },
        //   查询领取bounus
        async QueryBonuse(type = 0) {
            return this.request(GLOBAL_URL.QueryBonuse, { type }, { loading: false })
        },
        // 获取未读数据
        async getMsgUnread(loading = false) {
            return this.request(GLOBAL_URL.GetFriendsMeta, {}, { loading }).then((res) => {
                if (res.code === 200) {
                    this.unReadCount = {}
                    Object.keys(res.unreadmessages || {}).forEach((channel) => {
                        if (channel !== getChannel(10001, this.userInfo.uid)) {
                            const [, sender, reciever] = channel.match(/^(\d+):(\d+)$/)
                            const code = this.userInfo.uid == sender ? `${reciever}:${sender}` : `${sender}:${reciever}`
                            this.unReadCount[code] = res.unreadmessages[channel]
                        }
                    })
                    this.activeNum = res.activityzone || 0
                }
                return res
            })
        },
        // 获取最近20条数据
        async getHot20Msg(channel) {
            return await this.request(GLOBAL_URL.GetHotMsg, { channels: [channel] }, { loading: false })
        },
        async getChatHis({ channel, id, size = 10 }) {
            return await this.request(GLOBAL_URL.GetHisMsg, { channel, id, size }, { loading: false })
        },
        async sendText(params) {
            return this.request(GLOBAL_URL.SendText, params, { loading: false })
        },

        //  消息订阅
        async subscribe(channel) {
            return this.request(GLOBAL_URL.FriendsSubscribe, { channel }, { loading: false })
        },
        // 取消消息订阅
        async deSubscribe(channel) {
            return this.request(GLOBAL_URL.FriendsUnsubscribe, { channel }, { loading: false })
        },
        async Beanexchange(count: string) {
            return this.request(GLOBAL_URL.Beanexchange, { count: +count })
        },
        async getHeadermessage(pramas): Promise<HeaderMsg> {
            return this.request(GLOBAL_URL.Headermessage, pramas)
        },
        // 获取签到活动
        async getSignEvent(params: SignParam, tip = true, loading = true): Promise<SignRes> {
            return this.request(GLOBAL_URL.Sign, params, { tip, loading }).then((result) => {
                if (result.code === 200) {
                    this.setEntryIconData(params.id, result)
                }

                return result
            })
        },
        async ReceiveRewards(params: Receive): Promise<{ code: number; awards: { [key: string]: any } }> {
            return this.request(GLOBAL_URL.ReceiveRewards, params)
        },
        async OrderCancel(orderid: string) {
            return this.request(GLOBAL_URL.OrderCancel, { orderid })
        },
        // 聊天交易
        async SendChatGold(params: ChatTransferParam) {
            return this.request(GLOBAL_URL.ChatTransfer, params)
        },
        getPayoutRate(cny = 0, feepercent = 0, fee = 0) {
            return Number((Number(feepercent) * Number(cny) + Number(fee)).toFixed(4))
        },
        // 获取合伙人基础信息
        async getPartnerInfo(loading = true) {
            return getPartnerInfo(loading).then((res) => {
                if (res.code === 200) {
                    this.partnerInfo = res.data
                }
                return res
            })
        },
        // 合伙人获取上级聊天信息
        async getChatInfo(uid: number) {
            return this.request(GLOBAL_URL.Initiation, { uid })
        },
        // 获取所有活动
        async fetchallActivity(params) {
            return this.request(GLOBAL_URL.FetchallActivity, params, { loading: false, tip: false })
        },
    },
    persist: {
        key: 'playTok_base',
        storage: window.localStorage,
        paths: [
            'userInfo',
            'token',
            'lang',
            'wallet',
            'curSymbol',
            'newUser',
            'loginTime',
            'showVideoDrive',
            'chargeDate',
            'reelsConfig',
            'dramaStatus',
            'sex',
            'videoPlayed',
            'partnerDate',
            'depositOrder',
            'signDate',
            'prevGameTag',
            'pointAnimate',
            'closeBind',
            'parrnerRelationDate',
        ],
    },
})
